export default __webpack_public_path__ + "static/media/deep_bip(echo).4518258d.mp3";